import {Component, inject} from '@angular/core';
import {ColComponent, ContainerComponent, RowComponent} from "@coreui/angular";
import {MatError, MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {PlayersService} from "../../services/players.service";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from "@angular/forms";
import {PlayerInfoTableDefs} from "../../components/player-game-info/player-info-table-defs";
import {AgGridAngular} from "ag-grid-angular";
import {UIStateEnum} from "../../enum/UIStateEnum";
import {GridApi, GridReadyEvent} from "ag-grid-community";
import {IPlayerEmail} from "../../interfaces/player/IPlayerEmail";
import {IPlayerEmailFilterParams} from "../../interfaces/player/IPlayerEmailFilterParams";
import {MatCard} from "@angular/material/card";

@Component({
  selector: 'app-player-email-history',
  standalone: true,
  imports: [
    ContainerComponent,
    MatFormField,
    MatInput,
    MatButton,
    ReactiveFormsModule,
    AgGridAngular,
    MatLabel,
    MatError,
    RowComponent,
    ColComponent,
    MatCard
  ],
  templateUrl: './player-email-history.component.html',
  styleUrl: './player-email-history.component.css'
})
export class PlayerEmailHistoryComponent {

  private playerService = inject(PlayersService);
  private playerInfoTableDefs = inject(PlayerInfoTableDefs);

  public oldEmailControl: FormControl<string | null> = new FormControl('', Validators.email);
  public newEmailControl: FormControl<string | null> = new FormControl('', Validators.email);
  public playerIdControl: FormControl<string | null> = new FormControl('', this.guidValidator());

  public emailHistoryForm: FormGroup = new FormGroup({
    oldEmail: this.oldEmailControl,
    newEmail: this.newEmailControl,
    playerId: this.playerIdControl,
  });

  protected readonly uiStateEnum = UIStateEnum;
  public uiState = UIStateEnum.ShowData;
  public emailHistoryColDefs = this.playerInfoTableDefs.playerEmailHistoryColDefs;
  public emailHistoryGridApi!: GridApi<IPlayerEmail>
  public playerEmails: IPlayerEmail[] = [];

  public onSearchButtonClick() {
    if ((this.oldEmailControl.value == "" && this.newEmailControl.value == "" && this.playerIdControl.value == "") || !this.emailHistoryForm.valid) {
      return;
    }

    this.uiState = UIStateEnum.ShowLoading;

    let filter_params: IPlayerEmailFilterParams = {
      OldEmail: this.oldEmailControl.value!,
      NewEmail: this.newEmailControl.value!,
      PlayerId: this.playerIdControl.value!
    };

    this.playerService.getEmailChangeByFilterParams(filter_params).subscribe({
      next: email_changes => {
        this.playerEmails = email_changes;
        this.uiState = UIStateEnum.ShowData;
      },
      error: error => {
        this.uiState = UIStateEnum.ShowData;
      }
    });
  }

  public onEmailHistoryGridReady(params: GridReadyEvent<IPlayerEmail>) {
    this.emailHistoryGridApi = params.api;
    this.emailHistoryGridApi.sizeColumnsToFit({
      defaultMinWidth: 100
    });
  }

  private guidValidator(): ValidatorFn {
    let guid_regex = RegExp("^$|^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$");
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value.match(guid_regex))
      {
        return null;
      }
      return {error: "Invalid Guid"};
    }
  }

  onResetButtonClick() {
    this.oldEmailControl.setValue("");
    this.newEmailControl.setValue("");
    this.playerIdControl.setValue("");

    this.playerEmails = [];
  }
}
